'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSenderType = exports.getSenderId = exports.getMessageId = exports.getMessageUrl = exports.getClientRole = undefined;

var _reselect = require('reselect');

var _RoleTypes = require('conversations-schema/constants/RoleTypes');

var _RoleTypes2 = _interopRequireDefault(_RoleTypes);

var _SenderTypes = require('conversations-schema/constants/SenderTypes');

var _clientSelectors = require('conversations-core/selectors/clientSelectors');

var _widgetDataSelectors = require('conversations-core/selectors/widgetDataSelectors');

var _helpers = require('conversations-core/utils/helpers');

var _userSelectors = require('conversations-core/selectors/userSelectors');

var _prospectUtkSelectors = require('conversations-core/selectors/prospectUtkSelectors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getClientRole = exports.getClientRole = (0, _reselect.createSelector)(_clientSelectors.getIsAdmin, function (isAdmin) {
  if (isAdmin) {
    return _RoleTypes2.default.REP;
  }
  return _RoleTypes2.default.VISITOR;
});

var getMessageUrl = exports.getMessageUrl = (0, _reselect.createSelector)(_clientSelectors.getIsAdmin, function (isAdmin) {
  if (isAdmin) return null;
  return (0, _helpers.getUrlForMessage)();
});

var getMessageId = exports.getMessageId = (0, _reselect.createSelector)([_widgetDataSelectors.getWidgetData, _clientSelectors.getIsAdmin], function (widgetData, isAdmin) {
  if (isAdmin) return null;
  return widgetData.message.id;
});

var getSenderId = exports.getSenderId = (0, _reselect.createSelector)([_clientSelectors.getIsAdmin, _userSelectors.getUserId, _prospectUtkSelectors.getMessagesUtk], function (isAdmin, userId, messagesUtk) {
  if (isAdmin) return '' + userId;
  return messagesUtk;
});

var getSenderType = exports.getSenderType = (0, _reselect.createSelector)(_clientSelectors.getIsAdmin, function (isAdmin) {
  return isAdmin ? _SenderTypes.AGENT : _SenderTypes.VISITOR;
});


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/selectors/pubNubMessageSelectors.js
// module id = 96
// module chunks = 0 1